import { validateUrls } from "api/types"

export const urls = validateUrls({
  iqa: {
    updateReview: (reviewUuid: string | number | null) =>
      `/assignments/iqa/reviews/${reviewUuid}/`,
  },
})
